module.exports = __webpack_public_path__ + "static/media/ads3kb.cf6243a6.png";